import { defineComponent as _defineComponent } from 'vue'
import { ConversationEvent } from '@/entities/conversation'
import { timestampToDateTime } from '@/utils/time'

interface Props {
    events: ConversationEvent[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatResponseConversationEvents',
  props: {
    events: null
  },
  setup(__props: any) {

const props = __props as {
    events: ConversationEvent[]
}



const formatBotTags = (tags: string[]) => {
    if (!tags) {
        return '-'
    }

    return tags.join(', ')
}

return { __sfc: true,props, formatBotTags, timestampToDateTime }
}

})